import React from 'react';
import { StyleSheetManager } from 'styled-components';
import Routes from './routes';
import { OwsThemeProvider } from './nova/theme/OwsTheme';

const App = () => {
  if (window.config.inPrerender) {
    return (
      <StyleSheetManager disableCSSOMInjection>
        <OwsThemeProvider>
          <Routes />
        </OwsThemeProvider>
      </StyleSheetManager>
    );
  }

  return (
    <OwsThemeProvider>
      <Routes />
    </OwsThemeProvider>
  );
};

export default App;
